<div #iconWrapper class="field-lock">
    <i app-svg-icon name="padlock3" classList="icon  icon-12"></i>
</div>